import type { ComponentProps } from 'react';

import { cn } from '@/shared/lib/cn';

export function Skeleton({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      aria-hidden
      className={cn('skeleton-shimmer rounded-md', className)}
      {...props}
    />
  );
}
